import React, { useEffect, useMemo, useState } from 'react'
import { FormControl, TextField, Button, FormControlLabel, Radio, RadioGroup, Checkbox, Popover, FormLabel, Drawer, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Autocomplete, Snackbar, Alert } from '@mui/material'
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { useDispatch, useSelector } from 'react-redux';
import _, { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';
import { api } from '../../../redux/api';
import { decryptString, encryptString, stringifyJSONAttributes, stringToBooleanConversion } from '../../../utils/utilFunctions';
import { isInValidInput, sanitizeInput } from '../../../utils/validate';
import ErrorModal from '../../ItemProperties/Forms/FieldDataValidation/ErrorModal';
import { treeActions } from '../../../redux/slices/treeSlice';
import SmartPasswordField from '../../../commonComponents/SmartPasswordField';
import CloseIcon from '@mui/icons-material/Close';
import { MoreHorizOutlined } from '@mui/icons-material';
import WorkflowSessionModal from '../../ItemProperties/WorkflowSessionModal';

const FTP = (props) => {
    const { fileMaskName } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { rightTree } = useSelector((state) => state.treeData[state.treeData.currentScreen]);
    const currentTab = rightTree.currentTab;
    const selectedNode = rightTree.tree[currentTab].selectedNode;
    const connection = useSelector((state) => state?.treeData?.inbound?.connection);
    const { connectionDetails={}, connectionName='', handleBodyContent=() => {}, open = false , close = () => {}, account='', direction ='IN', screen='', disableControl = false, repoPDC={}, useConnection, source = "" } = props;
    const shouldEncryptDecryptPassword = String(source || "").toLowerCase() !== "pdc";
    const [ipAddress, setIpAddress] = useState('');
    const [optionalAccount, setOptionalAccount] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [fileDirectory, setFileDirectory] = useState('');
    const [fileMask, setFileMask] = useState('');
    const [createDir, setCreateDir] = useState(false);
    const [fileName, setFileName] = useState('');
    const [fileLocation, setFileLocation] = useState('');
    const [privateKeyPassword, setPrivateKeyPassword] = useState('');
    const [privateKeyPath, setPrivateKeyPath] = useState('');
    const [batch, setBatch] = useState(false);
    const [deleteFile, setDeleteFile] = useState(false);
    const [decompression, setDecompression] = useState(false);
    const [compression, setCompression] = useState(false);
    const [passive, setPassive] = useState(false);
    const [cache, setCache] = useState(true);
    const [showDecompressionDir, setShowDecompressionDir] = useState(false);
    const [decompressionDir, setDecompressionDir] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [decomPassword, setDecomPassword] = useState('');
    const [reUseSsl, setReUseSsl] = useState(false);
    const [ssh, setSsh] = useState(false);
    const [cmdBeforeGet, setCmdBeforeGet] = useState('');
    const [cmdAfterGet, setCmdAfterGet] = useState('');

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [ascii, setAscii] = useState(false);
    const [radio, setRadio] = useState('');
    const [implicitSsl, setImplicitSsl] = useState(false);
    const [explictSsl, setExplicitSsl] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [content, setContent] = useState(null);
    const [compressionList, setCompressionList] = useState([]);
    const [compressionType, setCompressionType] = useState('');
    const [fileNameZip, setFileNameZip] = useState('');
    const [showDestinationPassword, setShowDestinationPassword] = useState(false);
    const [destinationPassword, setDestinationPassword] = useState('');

    const [errorModal, setErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });
    const [valueLabel, setValueLabel] = useState("");
    const [workflowSessionModal, setWorkflowSessionModal] = useState({
    open: false,
    isFirstTime: false,
    });

    const workflowMappings = {
      [t("LBL_IP_ADDR")]: {
        stateSetter: setIpAddress,
        key: "CONNECTIONSTRING",
        value: ipAddress,
      },
      [t("LBL_ACC_OPTIONAL")]: {
        stateSetter: setOptionalAccount,
        key: "ACCOUNT",
        value: optionalAccount,
      },
      [t("LBL_USERNAME")]: {
        stateSetter: setUsername,
        key: "USERNAME",
        value: username,
      },
      [t('LBL_WS_PASSWORD')]: {
        stateSetter: setPassword,
        key: 'PASSWORD',
        value: password
      },
      [t("LBL_FILE_DIR")]: {
        stateSetter: setFileDirectory,
        key: "FILE_LOCATION",
        value: fileDirectory,
      },
      [t("LBL_FILE_NAME_MASK")]: {
        stateSetter: setFileMask,
        key: "FILENAMEMASK",
        value: fileMask,
      },
      [t("LBL_BATCH_DOWNLOAD_LOC")]: {
        stateSetter: setFileLocation,
        key: "BATCH_DOWNLOAD_LOC",
        value: fileLocation,
      },
      [t("LBL_DECOMPRESS_DIRECTORY")]: {
        stateSetter: setDecompressionDir,
        key: "DECOMPRESSION_DIRECTORY",
        value: decompressionDir,
      },
      [t("LBL_PASSWORD")]: {
        stateSetter: setDecomPassword,
        key: "ZIP_PASSWORD",
        value: decomPassword
      },
      [t("LBL_FILE_NAME")]: {
        stateSetter: setFileName,
        key: "FILENAME",
        value: fileName,
      },
    };

    const valuesHandler = (value) => {
        if (workflowMappings[valueLabel]) {
            const { stateSetter, key } = workflowMappings[valueLabel];
            if(key === 'PASSWORD' || key === 'ZIP_PASSWORD'){
                const encryptedValue =
                    key === "PASSWORD" && !shouldEncryptDecryptPassword
                        ? value
                        : encryptString(value, process.env.REACT_APP_SECRET_KEY2);
                stateSetter(value);
                onInputChange(key, encryptedValue);
            } else {
                stateSetter(value);
                onInputChange(key, value);
            }
            
        }
    };

    const getFontWeight = (control, currentValue, useConnection) => {
      if (!repoPDC) return "normal";
      // if (!(control in repoPDC)) return "normal";
      return repoPDC?.[control] !== currentValue &&
        useConnection === "preDefined"
        ? "bold"
        : "normal";
    };

    const fontWeights = useMemo(() => {
      return {
        ipAddress: getFontWeight("CONNECTIONSTRING", ipAddress, useConnection),
        optionalAccount: getFontWeight("ACCOUNT", optionalAccount, useConnection),
        username: getFontWeight("USERNAME", username, useConnection),
        password: getFontWeight("PASSWORD", password, useConnection),
        fileDirectory: getFontWeight("FILE_LOCATION", fileDirectory, useConnection),
        fileMask: getFontWeight("FILENAMEMASK", fileMask, useConnection),
        batchDownloadLoc: getFontWeight("BATCH_DOWNLOAD_LOC", fileLocation, useConnection),
        decompressionDir: getFontWeight("DECOMPRESSION_DIRECTORY", decompressionDir, useConnection),
        decomPassword: getFontWeight("ZIP_PASSWORD", decomPassword, useConnection),
        privateKeyPassword: getFontWeight("KEY_PASSWORD", privateKeyPassword, useConnection),
        privateKeyPath: getFontWeight("KEY", privateKeyPath, useConnection),
        fileName: getFontWeight("FILENAME", fileName, useConnection)
      };
    }, [ipAddress, optionalAccount, username, password, fileDirectory, fileMask, fileLocation, 
        decompressionDir, decomPassword, privateKeyPassword, privateKeyPath, useConnection, repoPDC, fileName]);
    
    const handleImplicit = () => {
        setImplicitSsl((prev) => {
            const newImplicitSsl = !prev;
            if (newImplicitSsl) {
                setExplicitSsl(false);
                onInputChange('SSL_STRATEGY', 'IMPLICIT');
            } else {
                onInputChange('SSL_STRATEGY', '');
            }
            return newImplicitSsl;
        });
        setSsh(false);
        onInputChange('SSH', stringifyJSONAttributes(false));
    };

    const handleExplicit = () => {
        setExplicitSsl((prev) => {
            const newExplicitSsl = !prev;
            if (newExplicitSsl) {
                setImplicitSsl(false);
                onInputChange('SSL_STRATEGY', 'EXPLICIT');
                onInputChange('SSL','TRUE');
            } else {
                // onInputChange('SSL_STRATEGY', '');
                 onInputChange('SSL','FALSE');
            }
            return newExplicitSsl;
        });
        setSsh(false);
        onInputChange('SSH', stringifyJSONAttributes(false));
    };


    const handleRadioChange = (event) => {
        onInputChange(event.target.name, event.target.value);
        if (stringToBooleanConversion(event.target.value)) setRadio('TRUE');
        else setRadio('FALSE');
    };

    const handleOpenPopover = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    const handleBlur = () => {
        const res = isInValidInput(fileName);
        if (res.inValid) {
            setErrorModal(true);
            setErrorMessage(res.message);
        } else {
            setErrorModal(false);
            setErrorMessage(res.message);
        }
    }

    const inputConverter = () => {
        const sanitizeResult = sanitizeInput(fileName);
        onInputChange('FILENAME', sanitizeResult);
        setFileName(sanitizeResult);
        setErrorModal(false);
        setErrorMessage('');
    }

    const handleCheckboxChange = (event) => {
        const value = event.target.value;
        setSelectedOptions((prev) =>
            prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
        );
    };

    const drawerWidth = 400;
    const handleBackdropClick = (event, reason) => {
        if (reason === 'backdropClick') return;
    };

    const debouncedContentUpdate = debounce(handleBodyContent, 500);

    const onInputChange = (name, value) => {
        if(['GET_DATA', 'SEND_DATA'].includes(screen)){
            setContent((prev) => ({ add:{ ...prev.add,  [name]: value} }));
            return;
        }
        setContent((prev) => {
            return { ...prev, [name]: value };
        });
    }

    const updateDetails = () => {
        dispatch(api.endpoints.getPdcDetail.initiate({
            account,
            direction: direction,
            name: encodeURIComponent(connectionName)
        }, { forceRefetch: true })).then(res => {
            if (res?.data?.current_state === 'SUCCESS' && res?.data?.data) {
                setCmdAfterGet(res.data?.data?.props?.POST_FTP_SCRIPT || '');
                setCmdBeforeGet(res.data?.data?.props?.PRE_FTP_SCRIPT || '');
            } 
            if (res?.data?.current_state === 'ERROR') setShowAlert({ mssg: res.data.message, isOpen: true, type: 'warning' });
        })
        setOpenModal(false);
    }

    const handleCancel = () => {
      setCmdBeforeGet(
        connectionDetails?.PRE_FTP_SCRIPT
          ? connectionDetails?.PRE_FTP_SCRIPT
          : ""
      );
      setCmdAfterGet(
        connectionDetails?.POST_FTP_SCRIPT
          ? connectionDetails?.POST_FTP_SCRIPT
          : ""
      );
      if (screen === "GET_DATA" || screen === "SEND_DATA") {
        setOpenModal(false);
        return;
      }
      updateDetails();
    };

    const handleDone = () => {
    
      onInputChange("PRE_FTP_SCRIPT", cmdBeforeGet ? cmdBeforeGet : null);
      
      onInputChange("POST_FTP_SCRIPT", cmdAfterGet ? cmdAfterGet : null);
      
      
      if (screen !== "GET_DATA" && screen !== "SEND_DATA") {
        const body = {
          ...connectionDetails,
          PRE_FTP_SCRIPT: cmdBeforeGet,
          POST_FTP_SCRIPT: cmdAfterGet,
          ADAPTER_TYPE: "FTP",
        };
        dispatch(
          treeActions.setConnection({
            screen: "inbound",
            value: { connectionName, ...body },
          })
        );
        dispatch(
          api.endpoints.createPdc.initiate(
            {
              account,
              direction: direction,
              name: encodeURIComponent(connectionName),
              oldPdcName: encodeURIComponent(connectionName),
              body,
            },
            { subscribe: false }
          )
        )
          .then((res) => {
            if (res?.data?.current_state === "SUCCESS") updateDetails();
            if (res?.data?.current_state === "ERROR")
              setShowAlert({
                mssg: res?.data?.message,
                isOpen: true,
                type: "error",
              });
          })
          .catch((err) => {
            setShowAlert({
              mssg: "Something went wrong while saving the connection.",
              isOpen: true,
              type: "error",
            });
          });
      }
      setOpenModal(false);
    };

    const handleAlertClose = () => {
        setShowAlert({ ...showAlert, isOpen: false });
    }

    useEffect(() => {
       if(!_.isEqual(content, connectionDetails)) debouncedContentUpdate(content);
    }, [content]);

    useEffect(() => {
        setIpAddress(connectionDetails?.CONNECTIONSTRING || '');
        setOptionalAccount(connectionDetails?.ACCOUNT || '');
        setUsername(connectionDetails?.USERNAME || '');
        setPassword(
            connectionDetails?.PASSWORD
                ? shouldEncryptDecryptPassword
                    ? decryptString(connectionDetails?.PASSWORD, process.env.REACT_APP_SECRET_KEY2)
                    : connectionDetails?.PASSWORD
                : ''
        );
        setFileDirectory(connectionDetails?.FILE_LOCATION || '');
        setFileLocation(connectionDetails?.BATCH_DOWNLOAD_LOC || '');
        setPrivateKeyPassword(connectionDetails?.KEY_PASSWORD ? connectionDetails?.KEY_PASSWORD : '');
        setPrivateKeyPath(connectionDetails?.KEY || '');
        setBatch(stringToBooleanConversion(connectionDetails?.BATCH_MODE));
        setDeleteFile(connectionDetails?.DELETE ? !stringToBooleanConversion(connectionDetails?.DELETE): false);
        setPassive(stringToBooleanConversion(connectionDetails?.PASSIVE_MODE));
        setCache(stringToBooleanConversion(connectionDetails?.CACHE_CONNECTION) || true);
        setDecompressionDir(connectionDetails?.DECOMPRESSION_DIRECTORY || '');
        if (connectionDetails?.DECOMPRESSION_DIRECTORY && connectionDetails?.DECOMPRESSION_DIRECTORY?.length !== 0) setShowDecompressionDir(true);
        else setShowDecompressionDir(false);
        setReUseSsl(stringToBooleanConversion(connectionDetails?.SSL_SESSION_REUSE));
        setCmdBeforeGet(connectionDetails?.PRE_FTP_SCRIPT ? connectionDetails?.PRE_FTP_SCRIPT : '');
        setCmdAfterGet(connectionDetails?.POST_FTP_SCRIPT ? connectionDetails?.POST_FTP_SCRIPT : '');
        if (connectionDetails?.ZIP) {
          direction === 'IN' ? setDecompression(true) : setCompression(true);
        }
        else {
          setDecompression(false);
          setCompression(false);
        }
        setShowPassword(stringToBooleanConversion(connectionDetails?.USE_ZIP_PASSWORD));
        setDecomPassword(connectionDetails?.ZIP_PASSWORD ? decryptString(connectionDetails?.ZIP_PASSWORD, process.env.REACT_APP_SECRET_KEY2) : '');
        if (stringToBooleanConversion(connectionDetails?.ASCII)) setRadio('TRUE');
        else setRadio('FALSE');
        setAscii(stringToBooleanConversion(connectionDetails?.ASCII) || false);
        setAnchorEl(null);
        if (stringToBooleanConversion(connectionDetails?.SSH)) {
            setSsh(stringToBooleanConversion(connectionDetails?.SSH));
            setImplicitSsl(false);
            setExplicitSsl(false);
            setReUseSsl(false);
        } else {
            if (connectionDetails?.SSL_STRATEGY) {
                if (connectionDetails?.SSL_STRATEGY === 'IMPLICIT') setImplicitSsl(true);
                if (connectionDetails?.SSL_STRATEGY === 'EXPLICIT') setExplicitSsl(true);
                setSsh(false);
            }
        }
        if (direction === 'IN') setFileMask(connectionDetails?.FILENAMEMASK || '');
        else {
            setCreateDir(stringToBooleanConversion(connectionDetails?.CREATE_DIRS) || false);
            setFileName(connectionDetails?.FILENAME || '');
        }
        setCompressionType(connectionDetails?.ZIP || 'ZIP');
        setFileNameZip(connectionDetails?.FILE_NAME_WITHIN_ZIP || '');
        if (direction === 'OUT') {
            setShowDestinationPassword(stringToBooleanConversion(connectionDetails?.USE_ZIP_PASSWORD));
            setDestinationPassword(connectionDetails?.ZIP_PASSWORD ? decryptString(connectionDetails?.ZIP_PASSWORD, process.env.REACT_APP_SECRET_KEY2) : '');
        }
        setContent({ ...connectionDetails });
    }, [connectionDetails]);

    useEffect(() => {
        if (direction === 'OUT') {
            dispatch(api.endpoints.getCompressionList.initiate()).then((res) => {
                if (res?.data?.current_state === 'SUCCESS') {
                    const types = Object.values(res?.data?.data)?.map((item) => item?.TYPE)
                    setCompressionList(types);
                }
                if (res?.data?.current_state === 'ERROR') setShowAlert({ mssg: res?.data?.message, isOpen: true, type: 'error' });
            });
        }
    }, [direction]);

    return (
      <>
        <div style={{ display: "flex", gap: "4px" }}>
          <FormControl className="width-100" size="small">
            <TextField
              variant="outlined"
              size="small"
              label={t("LBL_IP_ADDR")}
              disabled={disableControl || false}
              type="text"
              value={ipAddress || ""}
              inputProps={{
                style: { fontWeight: fontWeights.ipAddress }
              }}
              onChange={(e) => {
                setIpAddress(e.target.value);
                onInputChange(e.target.name, e.target.value);
              }}
              className={"width-100"}
              name={"CONNECTIONSTRING"}
              autoComplete="off"
            />
          </FormControl>
          {["GET_DATA", "SEND_DATA"].includes(screen) && (
            <WorkflowSessionModalButton
              disableControl={disableControl || false}
              label={t("LBL_IP_ADDR")}
              setWorkflowSessionModal={setWorkflowSessionModal}
              setValueLabel={setValueLabel}
            />
          )}
        </div>
        <div style={{ display: "flex", gap: "4px" }}>
          <FormControl className="width-100" size="small">
            <TextField
              variant="outlined"
              size="small"
              label={t("LBL_ACC_OPTIONAL")}
              type="text"
              value={optionalAccount || ""}
              disabled={disableControl || false}
              inputProps={{
                style: { fontWeight: fontWeights.optionalAccount }
              }}
              onChange={(e) => {
                setOptionalAccount(e.target.value);
                onInputChange(e.target.name, e.target.value || "");
              }}
              className={"width-100"}
              name={"ACCOUNT"}
              autoComplete="off"
            />
          </FormControl>
          {["GET_DATA", "SEND_DATA"].includes(screen) && (
            <WorkflowSessionModalButton
              disableControl={disableControl || false}
              label={t("LBL_ACC_OPTIONAL")}
              setWorkflowSessionModal={setWorkflowSessionModal}
              setValueLabel={setValueLabel}
            />
          )}
        </div>
        <div style={{ display: "flex", gap: "4px" }}>
          <FormControl className="width-100" size="small">
            <TextField
              variant="outlined"
              size="small"
              label={t("LBL_USERNAME")}
              type="text"
              value={username || ""}
              disabled={disableControl || false}
              inputProps={{
                style: { fontWeight: fontWeights.username }
              }}
              onChange={(e) => {
                setUsername(e.target.value);
                onInputChange("USERNAME", e.target.value);
              }}
              className={"width-100"}
              name={"USER_NAME"}
              autoComplete="off"
            />
          </FormControl>
          {["GET_DATA", "SEND_DATA"].includes(screen) && (
            <WorkflowSessionModalButton
              disableControl={disableControl || false}
              label={t("LBL_USERNAME")}
              setWorkflowSessionModal={setWorkflowSessionModal}
              setValueLabel={setValueLabel}
            />
          )}
        </div>
        <div style={{ display: "flex", gap: "4px" }}>
          <SmartPasswordField
            variant="outlined"
            size="small"
            label={t("LBL_WS_PASSWORD")}
            disabled={disableControl || false}
            value={password || ""}
            inputProps={{
              style: { fontWeight: fontWeights.password }
            }}
            onChange={(e) => {
              setPassword(e.target.value);
              onInputChange(
                "PASSWORD",
                shouldEncryptDecryptPassword
                  ? encryptString(e.target.value, process.env.REACT_APP_SECRET_KEY2)
                  : e.target.value
              );
            }}
            className={"width-100"}
            name={"PASS_WORD"}
            autoComplete="off"
          />
          {["GET_DATA", "SEND_DATA"].includes(screen) && (
            <WorkflowSessionModalButton
              disableControl={disableControl || false}
              label={t("LBL_WS_PASSWORD")}
              setWorkflowSessionModal={setWorkflowSessionModal}
              setValueLabel={setValueLabel}
            />
          )}
        </div>
        <div style={{ display: "flex", gap: "4px" }}>
          <FormControl className="width-100" size="small">
            <TextField
              variant="outlined"
              size="small"
              label={t("LBL_FILE_DIR")}
              type="text"
              value={fileDirectory}
              disabled={disableControl || false}
              inputProps={{
                style: { fontWeight: fontWeights.fileDirectory }
              }}
              onChange={(e) => {
                setFileDirectory(e.target.value);
                onInputChange(e.target.name, e.target.value);
              }}
              className={"width-100"}
              name={"FILE_LOCATION"}
              autoComplete="off"
            />
          </FormControl>
          {["GET_DATA", "SEND_DATA"].includes(screen) && (
            <WorkflowSessionModalButton
              disableControl={disableControl || false}
              label={t("LBL_FILE_DIR")}
              setWorkflowSessionModal={setWorkflowSessionModal}
              setValueLabel={setValueLabel}
            />
          )}
        </div>
        {direction === "IN" && (
          <div style={{ display: "flex", gap: "4px" }}>
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_FILE_NAME_MASK")}
                type="text"
                value={fileMask}
                disabled={disableControl || false}
                inputProps={{
                  style: { fontWeight: fontWeights.fileMask }
                }}
                onChange={(e) => {
                  setFileMask(e.target.value);
                  onInputChange(e.target.name, e.target.value);
                }}
                className={"width-100"}
                name={"FILENAMEMASK"}
                autoComplete="off"
              />
            </FormControl>
            {["GET_DATA", "SEND_DATA"].includes(screen) && (
              <WorkflowSessionModalButton
                disableControl={fileMaskName?.includes("*") || fileMaskName?.includes("?") || fileMaskName?.includes(":") || disableControl || false}
                label={t("LBL_FILE_NAME_MASK")}
                setWorkflowSessionModal={setWorkflowSessionModal}
                setValueLabel={setValueLabel}
              />
            )}
          </div>
        )}
        {direction === "OUT" && (
          <>
            <TPCheckbox
              label={t("BTN_CREATE_FILE_DIRECTORY")}
              checked={createDir}
              disabled={disableControl || false}
              handleCheck={(checked) => {
                onInputChange("CREATE_DIRS", stringifyJSONAttributes(checked));
                setCreateDir(checked);
              }}
            />
            <div style={{ display: "flex", gap: "4px" }}>
              <FormControl className="width-100" size="small">
                <TextField
                  variant="outlined"
                  size="small"
                  label={t("LBL_FILE_NAME")}
                  type="text"
                  value={fileName}
                  disabled={fileMaskName?.includes("*") || fileMaskName?.includes("?") || fileMaskName?.includes(":") || disableControl || false}
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                    setFileName(e.target.value);
                  }}
                  inputProps={{
                    style: { fontWeight: fontWeights.fileName }
                  }}
                  onBlur={handleBlur}
                  className={"width-100"}
                  name={"FILENAME"}
                  autoComplete="off"
                />
              </FormControl>
              {screen === "SEND_DATA" && (
                <WorkflowSessionModalButton
                  disableControl={ disableControl || false}
                  label={t("LBL_FILE_NAME")}
                  setWorkflowSessionModal={setWorkflowSessionModal}
                  setValueLabel={setValueLabel}
                />
              )}
            </div>
          </>
        )}
        <Button variant="outlined" onClick={handleOpenPopover} size="small" disabled={disableControl || false}>
          Options...
        </Button>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}>
          <div
            style={{ padding: "16px", width: "200px", position: "relative" }}>
            <IconButton
              style={{ position: "absolute", top: 0, right: 0 }}
              onClick={handleClosePopover}>
              <CloseIcon />
            </IconButton>
            <TPCheckbox
              label={t("BTN_PROCESS_AS_BATCH")}
              checked={batch}
              handleCheck={(checked) => {
                onInputChange("BATCH_MODE", stringifyJSONAttributes(checked));
                selectedNode?.ICON_DISPLAY === "SEND_DATA" && onInputChange("OUTBOUND_NAME", null);
                selectedNode?.ICON_DISPLAY === "SEND_DATA" && onInputChange("SOURCE_TYPE", "LOCAL_FILE_SYSTEM");
                setBatch(checked);
                if (!checked) {
                  setFileLocation("");
                }
              }}
            />
            {direction === "OUT" && (
              <TPCheckbox
                label={t("BTN_USE_ZIP_COMPRESS")}
                checked={compression}
                handleCheck={(checked) => {
                  onInputChange(
                    "ZIP",
                    checked ? "ZIP" : null
                  );
                  setCompression(checked);
                  checked && setCompressionType("ZIP");
                  if (!checked) {
                    setFileNameZip("");
                    onInputChange(
                      "FILE_NAME_WITHIN_ZIP",
                      null
                    );
                  }
                }}
              />
            )}
            {direction === "IN" && (
              <TPCheckbox
                label={t("BTN_DO_NOT_DELETE")}
                checked={deleteFile}
                handleCheck={(checked) => {
                  onInputChange("DELETE", stringifyJSONAttributes(!checked));
                  setDeleteFile(checked);
                }}
              />
            )}
            {direction === "IN" && (
              <TPCheckbox
                label={t("BTN_USE_ZIP_DECOMPRESS")}
                checked={decompression}
                handleCheck={(checked) => {
                  if (checked) onInputChange("ZIP", "ZIP");
                  else onInputChange("ZIP", null);
                  setDecompression(checked);
                  if (!checked) {
                    onInputChange(
                      "SPECIFY_DECOMPRESSION_DIRECTORY", null
                    );
                    setShowDecompressionDir(false);
                    onInputChange("DECOMPRESSION_DIRECTORY", null);
                    setDecompressionDir("");
                    onInputChange(
                      "USE_ZIP_PASSWORD", null
                    );
                    setShowPassword(false);
                    onInputChange("ZIP_PASSWORD", null);
                    setPassword("");
                  }
                }}
              />
            )}
            <TPCheckbox
              label={t("BTN_PASSIVE")}
              checked={passive}
              handleCheck={(checked) => {
                onInputChange("PASSIVE_MODE", stringifyJSONAttributes(checked));
                setPassive(checked);
              }}
            />
            <TPCheckbox
              label={t("BTN_CACHE_CONN")}
              checked={cache}
              handleCheck={(checked) => {
                onInputChange(
                  "CACHE_CONNECTION",
                  stringifyJSONAttributes(checked)
                );
                setCache(checked);
              }}
            />
            <hr />
            <RadioGroup
              row
              name={"ASCII"}
              value={radio}
              onChange={(e) => {
                handleRadioChange(e);
              }}>
              <FormControlLabel
                value="FALSE"
                control={<Radio />}
                label={t("BTN_BINARY_MODE")}
              />
              <FormControlLabel
                value="TRUE"
                control={<Radio />}
                label={t("BTN_ASCII_MODE")}
              />
            </RadioGroup>
            <hr />
            <FormControlLabel
              control={
                <Checkbox
                  checked={explictSsl}
                  onChange={handleExplicit}
                  sx={{
                    transform: "scale(0.9)",
                  }}
                  value={"EXPLICIT"}
                />
              }
              label={t("BTN_SSL_EXPLICIT")}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={implicitSsl}
                  onChange={handleImplicit}
                  sx={{
                    transform: "scale(0.9)",
                  }}
                  value={"IMPLICIT"}
                />
              }
              label={t("BTN_SSL_IMPLICIT")}
            />
            {(implicitSsl || explictSsl) && (
              <TPCheckbox
                label={t("BTN_SSL_SESSION_REUSE")}
                checked={reUseSsl}
                handleCheck={(checked) => {
                  onInputChange(
                    "SSL_SESSION_REUSE",
                    stringifyJSONAttributes(checked)
                  );
                  setReUseSsl(checked);
                  onInputChange("SSH", stringifyJSONAttributes(false));
                  setSsh(false);
                }}
              />
            )}
            <hr />
            <TPCheckbox
              label={t("BTN_SSH")}
              checked={ssh}
              handleCheck={(checked) => {
                onInputChange("SSH", stringifyJSONAttributes(checked));
                setSsh(checked);
                if (checked) {
                  setImplicitSsl(false);
                  setExplicitSsl(false);
                  setReUseSsl(false);
                  onInputChange("SSL_STRATEGY", null);
                  onInputChange(
                    "SSL_SESSION_REUSE",
                    null
                  );
                }
              }}
            />
          </div>
        </Popover>

        {compression && direction === "OUT" && (
          <>
            <Autocomplete
              disablePortal
              options={compressionList}
              disabled={disableControl || false}
              getOptionLabel={(option) => option}
              value={compressionType}
              sx={{ maxHeight: 300 }}
              onChange={(e, value) => {
                onInputChange("ZIP", value);
                setCompressionType(value);
                if (["GZ", "TAR", "TGZ"].includes(value)) {
                  onInputChange(
                    "USE_ZIP_PASSWORD", null
                  );
                  setShowDestinationPassword(false);
                  onInputChange("ZIP_PASSWORD", null);
                  setDestinationPassword("");
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("LBL_COMPRESSION_TYPE")}
                  onChange={(e) => {
                    const value = e.target.value;
                    onInputChange("ZIP", value);
                    setCompressionType(value);
                    if (["GZ", "TAR", "TGZ"].includes(value)) {
                      onInputChange(
                        "USE_ZIP_PASSWORD", null
                      );
                      setShowDestinationPassword(false);
                      onInputChange("ZIP_PASSWORD", null);
                      setDestinationPassword("");
                    }
                  }}
                  variant="outlined"
                  size="small"
                  name={"COMPRESSION_TYPE"}
                  autoComplete="off"
                />
              )}
            />
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("FILE_NAME_WITHIN_ZIP")}
                type="text"
                value={fileNameZip || ""}
                onChange={(e) => {
                  onInputChange(e.target.name, e.target.value);
                  setFileNameZip(e.target.value);
                }}
                className={"width-100"}
                name={"FILE_NAME_WITHIN_ZIP"}
                autoComplete="off"
              />
            </FormControl>
            {["JAR", "RAR", "ZIP"].includes(compressionType) && (
              <>
                <div>
                  <TPCheckbox
                    label={t("LBL_WS_PASSWORD")}
                    checked={showDestinationPassword}
                    disabled={disableControl || false}
                    handleCheck={(checked) => {
                      onInputChange(
                        "USE_ZIP_PASSWORD",
                        stringifyJSONAttributes(checked)
                      );
                      setShowDestinationPassword(checked);
                      if (!checked) {
                        onInputChange("ZIP_PASSWORD", null);
                        setDestinationPassword("");
                      }
                    }}
                  />
                </div>
                {showDestinationPassword && (
                  <SmartPasswordField
                    variant="outlined"
                    size="small"
                    type="password"
                    label={t("LBL_WS_PASSWORD")}
                    value={destinationPassword || ""}
                    onChange={(e) => {
                      onInputChange(e.target.name, encryptString(e.target.value, process.env.REACT_APP_SECRET_KEY2));
                      setDestinationPassword(e.target.value);
                    }}
                    className={"width-100"}
                    name={"ZIP_PASSWORD"}
                    autoComplete="off"
                  />
                )}
              </>
            )}
          </>
        )}

        {batch && direction === "IN" && (
          <>
            <FormLabel>{t("LBL_USING_BATCH")}</FormLabel>
            <div style={{ display: "flex", gap: "4px" }}>
              <FormControl className="width-100" size="small">
                <TextField
                  variant="outlined"
                  size="small"
                  label={t("LBL_BATCH_DOWNLOAD_LOC")}
                  type="text"
                  value={fileLocation || ""}
                  disabled={disableControl || false}
                  inputProps={{
                    style: { fontWeight: fontWeights.batchDownloadLoc }
                  }}
                  onChange={(e) => {
                    setFileLocation(e.target.value);
                    onInputChange(e.target.name, e.target.value);
                  }}
                  className={"width-100"}
                  name={"BATCH_DOWNLOAD_LOC"}
                  autoComplete="off"
                />
              </FormControl>
              {["GET_DATA", "SEND_DATA"].includes(screen) && (
                <WorkflowSessionModalButton
                  disableControl={disableControl || false}
                  label={t("LBL_BATCH_DOWNLOAD_LOC")}
                  setWorkflowSessionModal={setWorkflowSessionModal}
                  setValueLabel={setValueLabel}
                />
              )}
            </div>
          </>
        )}

        {(implicitSsl || explictSsl || ssh) && (
          <>
            <SmartPasswordField
              variant="outlined"
              size="small"
              label={t("LBL_PRIVATE_KEY_PASSWORD")}
              value={privateKeyPassword || ""}
              disabled={disableControl || false}
              inputProps={{
                style: { fontWeight: fontWeights.privateKeyPassword }
              }}
              onChange={(e) => {
                setPrivateKeyPassword(e.target.value);
                onInputChange(
                  e.target.name,
                  encryptString(
                    e.target.value,
                    process.env.REACT_APP_SECRET_KEY2
                  )
                );
              }}
              className={"width-100"}
              name={"KEY_PASSWORD"}
              autoComplete="off"
            />
            <FormControl className="width-100" size="small">
              <TextField
                variant="outlined"
                size="small"
                label={t("LBL_PATH_TO_PRIVATE_KEY")}
                type="text"
                value={privateKeyPath || ""}
                disabled={disableControl || false}
                inputProps={{
                  style: { fontWeight: fontWeights.privateKeyPath }
                }}
                onChange={(e) => {
                  setPrivateKeyPath(e.target.value);
                  onInputChange(e.target.name, e.target.value);
                }}
                className={"width-100"}
                name={"KEY"}
                autoComplete="off"
              />
            </FormControl>
          </>
        )}

        {decompression && (
          <>
            <div>
              <TPCheckbox
                label={t("LBL_SPECIFY_DECOMPRESSION_DIRECTORY")}
                checked={showDecompressionDir}
                disabled={disableControl || false}
                handleCheck={(checked) => {
                  onInputChange(
                    "SPECIFY_DECOMPRESSION_DIRECTORY",
                    stringifyJSONAttributes(checked)
                  );
                  setShowDecompressionDir(checked);
                }}
              />
            </div>
            {showDecompressionDir && (
              <div style={{ display: "flex", gap: "4px" }}>
                <FormControl className="width-100" size="small">
                  <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_DECOMPRESS_DIRECTORY")}
                    type="text"
                    value={decompressionDir || ""}
                    disabled={disableControl || false}
                    inputProps={{
                      style: { fontWeight: fontWeights.decompressionDir }
                    }}
                    onChange={(e) => {
                      setDecompressionDir(e.target.value);
                      onInputChange(e.target.name, e.target.value);
                    }}
                    className={"width-100"}
                    name={"DECOMPRESSION_DIRECTORY"}
                    autoComplete="off"
                  />
                </FormControl>
                {["GET_DATA", "SEND_DATA"].includes(screen) && (
                  <WorkflowSessionModalButton
                    disableControl={disableControl || false}
                    label={t("LBL_DECOMPRESS_DIRECTORY")}
                    setWorkflowSessionModal={setWorkflowSessionModal}
                    setValueLabel={setValueLabel}
                  />
                )}
              </div>
            )}
            <div>
              <TPCheckbox
                label={t("LBL_WS_PASSWORD")}
                checked={showPassword}
                disabled={disableControl || false}
                handleCheck={(checked) => {
                  onInputChange(
                    "USE_ZIP_PASSWORD",
                    stringifyJSONAttributes(checked)
                  );
                  setShowPassword(checked);
                }}
              />
            </div>
            {showPassword && (
              <div style={{ display: "flex", gap: "4px" }}>
                <SmartPasswordField
                  variant="outlined"
                  size="small"
                  label={t("LBL_PASSWORD")}
                  value={decomPassword || ""}
                  disabled={disableControl || false}
                  sx={{ input: { fontWeight: fontWeights.decomPassword } }}
                  onChange={(e) => {
                    setDecomPassword(e.target.value);
                    onInputChange(
                      e.target.name,
                      encryptString(
                        e.target.value,
                        process.env.REACT_APP_SECRET_KEY2
                      )
                    );
                  }}
                  className={"width-100"}
                  name={"ZIP_PASSWORD"}
                  autoComplete="off"
                />
                {["GET_DATA", "SEND_DATA"].includes(screen) && (
                  <WorkflowSessionModalButton
                    disableControl={disableControl || false}
                    label={t("LBL_PASSWORD")}
                    setWorkflowSessionModal={setWorkflowSessionModal}
                    setValueLabel={setValueLabel}
                  />
                )}
              </div>
            )}
          </>
        )}
        <Button
          className="width-100"
          size="small"
          variant="outlined"
          disabled={disableControl || false}
          onClick={() => {
            if (
              !connectionDetails?.PRE_FTP_SCRIPT &&
              connection?.ADAPTER_TYPE === "FTP" &&
              connectionName === connection?.connectionName
            )
              setCmdBeforeGet(connection?.PRE_FTP_SCRIPT || "");
            if (
              !connectionDetails?.POST_FTP_SCRIPT &&
              connection?.ADAPTER_TYPE === "FTP" &&
              connectionName === connection?.connectionName
            )
              setCmdAfterGet(connection?.POST_FTP_SCRIPT || "");
            setOpenModal(true);
          }}>
          {t("BTN_USE_ADV_SCRIPTING")}
          {cmdBeforeGet !== "" || cmdAfterGet !== "" ? `(${t("SET")})` : ""}
        </Button>
        <Drawer
          anchor="left"
          open={openModal}
          onClose={() => setOpenModal(false)}
          ModalProps={{
            onClose: handleBackdropClick,
          }}
          SlideProps={{
            style: {
              transform: openModal ? "translateX(0)" : "translateX(-240px)",
            },
          }}
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              boxShadow: "none",
            },
          }}>
          <div style={{ borderRight: "solid 1px #e0e0e0", height: "100%" }}>
            <div
              className="flex-column height-100"
              style={{ backgroundColor: "#fff", position: "relative" }}>
              <div className="quick-add-container padding-16">
                <div style={{ lineHeight: "25px" }}>
                  <p style={{ marginBottom: "10px" }}>
                    {t("DIAG_ADV_FTP_SCRIPTING_TIT")}
                  </p>
                  <div className="font-12">
                    <p>{t("DIAG_ADV_FTP_SCRIPTING_DESC")}</p>
                  </div>
                </div>
              </div>
              <hr />
              <div style={{ lineHeight: "25px" }} className="padding-16">
                <FormControl className="width-100" size="small">
                  <TextField
                    multiline
                    rows={4}
                    variant="outlined"
                    size="small"
                    label={t("LBL_EXE_COMM_BEFORE_GET")}
                    type="text"
                    value={cmdBeforeGet || ""}
                    onChange={(e) => {
                      setCmdBeforeGet(e.target.value);
                      // onInputChange(e.target.name, e.target.value);
                    }}
                    className={"width-100"}
                    name={"PRE_FTP_SCRIPT"}
                    autoComplete="off"
                  />
                </FormControl>
              </div>
              <div style={{ lineHeight: "25px" }} className="padding-16">
                <FormControl className="width-100" size="small">
                  <TextField
                    multiline
                    rows={4}
                    variant="outlined"
                    size="small"
                    label={t("LBL_EXE_COMM_AFTER_GET")}
                    type="text"
                    value={cmdAfterGet || ""}
                    onChange={(e) => {
                      setCmdAfterGet(e.target.value);
                      // onInputChange(e.target.name, e.target.value);
                    }}
                    className={"width-100"}
                    name={"POST_FTP_SCRIPT"}
                    autoComplete="off"
                  />
                </FormControl>
              </div>
              <div className="margin-top-16 margin-left-16">
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => handleDone()}>
                  {t("BTN_DONE")}
                </Button>
                <Button
                  size="small"
                  className="margin-left-4"
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    handleCancel();
                  }}>
                  {t("CANCEL")}
                </Button>
              </div>
            </div>
          </div>
        </Drawer>
        {screen !== "GET_DATA" && (
          <TestConnection
            ipAddress={ipAddress}
            username={username}
            password={password}
            cacheConnection={cache}
            fileNameMask={fileMask}
            fileName={fileName}
            ssh={ssh}
            open={open}
            close={close}
            account={account}
            direction={direction}
          />
        )}
        <ErrorModal
          errorModal={errorModal}
          setErrorModal={() => setErrorModal(false)}
          errorMessage={errorMessage}
          OkHandler={inputConverter}
        />
        <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
          <Alert
            onClose={() => handleAlertClose()}
            severity={showAlert.type}
            variant="filled"
            sx={{ width: "100%" }}>
            {showAlert.mssg}
          </Alert>
        </Snackbar>

        <WorkflowSessionModal
          valueLabel={valueLabel}
          showAccountData={true}
          showCallingWorkflow={true}
          showSystemData={true}
          showWorkflowSession={true}
          showDateAndTime={true}
          openModal={workflowSessionModal}
          setModalOpen={setWorkflowSessionModal}
          handleClose={() =>
            setWorkflowSessionModal({ open: false, isFirstTime: false })
          }
          initialValue={workflowMappings[valueLabel]?.value}
          inputType={[t('LBL_WS_PASSWORD'), t("LBL_PASSWORD") ].includes(valueLabel) ? "password" : "text"}
          specialPasswordField={[t('LBL_WS_PASSWORD'), t("LBL_PASSWORD") ].includes(valueLabel)}
          valuesHandler={(value) => {
            valuesHandler(value);
          }}
        />
      </>
    );
}

export default FTP

const WorkflowSessionModalButton = ({setWorkflowSessionModal, label, disableControl, setValueLabel}) => {
  return (
    <Button
      size="small"
      disabled={disableControl || false}
      variant="outlined"
      onClick={() => {
        setValueLabel(label);
        setWorkflowSessionModal({ open: true, isFirstTime: true });
      }}
      sx={{ width: "40px", minWidth: "40px" }}>
      <MoreHorizOutlined fontSize="small" />
    </Button>
  );
};
export const TestConnection = ({ open = false, close=() =>{}, account='', username, password, fileName, fileNameMask, cacheConnection, ssl, ssh, ipAddress, direction }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [message, setMessage] = useState('');
    const checkConnection = () => {
        dispatch(api.endpoints.testPdcConnection.initiate({
            account: account,
            direction: direction,
            body: {
                direction: direction,
                ADAPTER_TYPE: 'FTP',
                CONNECTIONSTRING: ipAddress,
                USERNAME: username,
                PASSWORD: password,
                FILENAMEMASK: fileNameMask,
                FILENAME: fileName,
                CACHE_CONNECTION: cacheConnection,
                SSL: ssl,
                SSH: stringifyJSONAttributes(ssh),
                ACCOUNT: '',
                BATCH_DOWNLOAD_LOC: '',
                DELETE: '',
                DECOMPRESSION_DIRECTORY_CB: '',
                DECOMPRESSION_DIRECTORY: '',
                FILE_LOCATION: '',
                CREATE_DIRS: '',
                FILENAME: '',
                BATCH_MODE: 'FALSE',
                ZIP_CB: 'FALSE',
                PASSIVE_MODE: 'FALSE',
                FTP_MODE: 'FALSE',
                FTP_PROTOCOL: '',
                SSL_SESSION_REUSE: '',
                KEY_PASSWORD: '',
                KEY: '',
                ZIP: '',
                FILE_NAME_WITHIN_ZIP: '',
                USE_ZIP_PASSWORD_CB: '',
                ZIP_PASSWORD: '',
                PRE_FTP_SCRIPT: '',
                POST_FTP_SCRIPT: ''
            }
        }))
            .then((res) => {
                if (res?.data?.current_state === 'SUCCESS') {
                    setMessage(res?.data?.data);
                } else setMessage(`${res?.data?.message}`);
            })
    }

    useEffect(() => {
        setMessage(`${t('LBL_CONNECTING_TO_SERVER')} ${ipAddress} as ${username}`);
        if (open)
            checkConnection();
    }, [open]);

    return (
        <>
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className='dialog-header'>
                    <div className="title">{t('DIAG_TEST_CONNECTION_TIT')}</div>
                    <div className="description">{t('DIAG_TEST_CONNECTION_DESC')}</div>
                </DialogTitle>

                <DialogContent className='modal-content' dividers>
                    {message}
                </DialogContent>

                <DialogActions>
                    <Button
                        size="small"
                        onClick={() => close(false)}
                        variant={"outlined"}
                    >
                        {t("BTN_DONE")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}